import { render, staticRenderFns } from "./charteredFinancial.vue?vue&type=template&id=568c1d52&scoped=true"
import script from "./charteredFinancial.vue?vue&type=script&lang=js"
export * from "./charteredFinancial.vue?vue&type=script&lang=js"
import style0 from "./charteredFinancial.vue?vue&type=style&index=0&id=568c1d52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568c1d52",
  null
  
)

export default component.exports